// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceModelId } from './DeviceModel';
import { z } from 'zod';
export const deviceModelPhaseId = (z.number());
export const deviceModelPhase = z.object({
    id: deviceModelPhaseId,
    device_model_id: deviceModelId,
    phase_id: z.string(),
    label: z.string(),
    description: z.string().nullable(),
    sort_order: z.number(),
    transitions: z.unknown(),
    created_at: z.date(),
    updated_at: z.date(),
    guards: z.unknown(),
});
export const deviceModelPhaseInitializer = z.object({
    id: deviceModelPhaseId.optional(),
    device_model_id: deviceModelId,
    phase_id: z.string(),
    label: z.string(),
    description: z.string().optional().nullable(),
    sort_order: z.number(),
    transitions: z.unknown().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    guards: z.unknown().optional(),
});
export const deviceModelPhaseMutator = z.object({
    id: deviceModelPhaseId.optional(),
    device_model_id: deviceModelId.optional(),
    phase_id: z.string().optional(),
    label: z.string().optional(),
    description: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    transitions: z.unknown().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    guards: z.unknown().optional(),
});
//# sourceMappingURL=DeviceModelPhase.js.map